import { Directive, inject } from '@angular/core';
import { MultiSelect } from 'primeng/multiselect';

@Directive({
  selector: '[appPrimengMultiselect]',
  standalone: true,
})
export class PrimengMultiselectDirective {
  private readonly multiselect = inject(MultiSelect);

  public constructor() {
    this.configure();
  }

  public configure(): void {
    this.multiselect.showClear = true;
  }
}
